export default "__VITE_ASSET__8T1l_X9I__"